import moment from 'moment';
/* tslint:disable:max-classes-per-file */
function calc_hourvalue_from_hour_min(hour: number, min: number): number {
  return hour + min / 60;
}

function calc_hourvalue_from_date(dt: Date): number {
  return calc_hourvalue_from_hour_min(dt.getHours(), dt.getMinutes());
}

export const DEFAULT_DAY_BEGINTIME = calc_hourvalue_from_hour_min(6, 0);
export const DEFAULT_DAY_ENDTIME = calc_hourvalue_from_hour_min(22, 0);

function hours_from_delta(a: Date, b: Date): number {
  return (a.getTime() - b.getTime()) / 3600000.;
}

function dates_equal(a: Date, b: Date): boolean {
  return a.getTime() === b.getTime();
}

class HourRange {
  public dt: Date;
  public begin: Date;
  public end: Date;
  public isDay: boolean;
  constructor(dt: Date, begin: Date, end: Date, isDay: boolean) {
    this.dt = dt;
    this.begin = begin;
    this.end = end;
    this.isDay = isDay;
  }

  public equals(other: HourRange): boolean {
    return dates_equal(this.begin, other.begin) && dates_equal(this.end, other.end) && this.isDay === other.isDay;
  }
  public begin_diff(): number {
    return hours_from_delta(this.dt, this.begin);
  }
  public end_diff(): number {
    return hours_from_delta(this.end, this.dt);
  }
}

class HourResult {
  public day: number;
  public night: number;
  public total: number;
  constructor() {
    this.day = this.night = this.total = 0;
  }
  public add(hrs: number, isDay: boolean) {
    if (isDay) {
      this.day += hrs;
    } else {
      this.night += hrs;
    }
    this.total += hrs;
  }
}

function date_combine(dt: Date, tmValue: number, addDays: number = 0): Date {
  // console.log('date_combine', dt, tmValue, addDays);
  const newDt = new Date(dt);
  if (addDays !== 0) {
    newDt.setDate(dt.getDate() + addDays);
  }
  newDt.setHours(Math.floor(tmValue));
  newDt.setMinutes((tmValue % 1) * 60);
  // console.log('date_combine out', newDt);
  return newDt;
}

function calc_bounds(dt: Date, dayBeginTm: number, dayEndTm: number): HourRange {
  // console.log('calc_bounds', dt);
  const tm = calc_hourvalue_from_date(dt);
  if (tm < dayBeginTm) {
    const begin = date_combine(dt, dayEndTm, -1);
    const end = date_combine(dt, dayBeginTm);
    const isDay = false;
    return new HourRange(dt, begin, end, isDay);
  } else if (dayBeginTm <= tm && tm < dayEndTm) {
    const begin = date_combine(dt, dayBeginTm);
    const end = date_combine(dt, dayEndTm);
    const isDay = true;
    return new HourRange(dt, begin, end, isDay);
  } else {
    const begin = date_combine(dt, dayEndTm);
    const end = date_combine(dt, dayBeginTm, 1);
    const isDay = false;
    return new HourRange(dt, begin, end, isDay);
  }
}
function parse_utc(value: string): Date {
  return moment.utc(value).local().toDate();
}
export function calc_day_night_hours(beginStr: string|null, endStr: string|null, dayBeginTm: number, dayEndTm: number): HourResult {
  // console.log('calc_day_night_hours', beginStr, endStr, dayBeginTm, dayEndTm);
  const result = new HourResult();
  if (beginStr && endStr) {
    const beginDt = parse_utc(beginStr);
    const endDt = parse_utc(endStr);
    // console.log(beginStr, endStr);
    // console.log(beginDt, endDt);
    if (beginDt < endDt) {
      const beginRange = calc_bounds(beginDt, dayBeginTm, dayEndTm);
      const endRange = calc_bounds(endDt, dayBeginTm, dayEndTm);
      if (beginRange.equals(endRange)) {
        result.add(beginRange.end_diff() - endRange.end_diff(), endRange.isDay);
      } else {
        // console.log('beginRange', beginRange);
        // console.log('endRange', endRange);
        result.add(beginRange.end_diff(), beginRange.isDay);
        let curRange = beginRange;
        while (!curRange.equals(endRange) && !dates_equal(curRange.end, endRange.begin)) {
          curRange = calc_bounds(curRange.end, dayBeginTm, dayEndTm);
          // console.log('curRange', curRange);
          result.add(curRange.end_diff(), curRange.isDay);
        }
        result.add(endRange.begin_diff(), endRange.isDay);
      }
    }
  }
  return result;
}


function do_test(beginStr: string, endStr: string, expectedDay: number, expectedNight: number) {
  const result = calc_day_night_hours(beginStr, endStr, DEFAULT_DAY_BEGINTIME, DEFAULT_DAY_ENDTIME);
  console.log(result, expectedDay, expectedNight);
  console.assert(result.day === expectedDay && result.night === expectedNight);
}

export function test_date_calculations() {
  do_test('2023-01-09T06:30:00', '2023-01-09T16:30:00', 10, 0);
  do_test('2023-01-09T01:30:00', '2023-01-09T02:30:00', 0, 1);
  do_test('2023-01-09T21:30:00', '2023-01-09T23:30:00', 0, 2);
  do_test('2023-01-09T21:30:00', '2023-01-09T21:30:00', 0, 0);
  do_test('2023-01-09T06:30:00', '2023-01-09T21:30:00', 11.5, 3.5);
  do_test('2023-01-09T23:30:00', '2023-01-10T02:30:00', 0, 3);
  do_test('2023-01-09T15:30:00', '2023-01-10T02:30:00', 2.5, 8.5);
  do_test('2023-01-09T15:30:00', '2023-01-10T10:30:00', 7, 12);
  do_test('2023-01-09T15:30:00', '2023-01-10T21:30:00', 14.5, 15.5);
}


export function new_curdatetime(): string {
  const t = moment().hour(0).minute(0).second(0);
  return t.utc().format();
}

export function new_curdate(): string {
  const t = moment().hour(0).minute(0).second(0);
  return t.format('YYYY-MM-DD');
}

export function copy_datetime(value: string): string {
  const t = moment.utc(value).local().hour(0).minute(0).second(0);
  return t.utc().format();
}

export function endOfMonth(dt: string): string {
  return moment(dt).endOf('month').format('YYYY-MM-DD');
}



export function round_euro(v: number): number {
  // console.log('round_euro', v, Math.round((v + Number.EPSILON) * 100) / 100);
  return Math.round((v + Number.EPSILON) * 100) / 100;
}

export default {
    test01() {
      test_date_calculations();
    }
};
